import { BasePagedSearchCriteria } from "./BaseSearchCriteria";

export interface LicenseSearchCriteria extends BasePagedSearchCriteria{

    name?:string;
    type?:string[];
    
}

export const LICENSE_SEARCH_CRITERIA_KEY = 'LicenseSearchCriteria';